import { render, staticRenderFns } from "./DirectDealsIcon.vue?vue&type=template&id=44b3e333&"
import script from "./DirectDealsIcon.vue?vue&type=script&lang=js&"
export * from "./DirectDealsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports